import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
// import { IonTabs } from '@ionic/angular';
import type { ModalOptions } from '@ionic/angular';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { MyTimestampPipe } from '@shared/pipes';
import { TripsService, UsersService } from '@shared/services';
import { CheckboxModalPage, ViewBasePage } from '@shared/pages';
import type { TResponse, TAlertResponse, TTimestamp } from '@shared/models';

type TFilter = {
    startingDate: TTimestamp,
    endingDate: TTimestamp,
    minimumTripDurationMins: number,
    allDriverNames: string[],
    selectedDrivers: string[],

    // Do we need these or are they duplicates of startingDate and endingDate?
    dateRangeStart: TTimestamp,
    dateRangeEnd: TTimestamp,
};

type TVM = {
    filter: TFilter;
    tripData: any;
};

type TSelectable = {
    'line1': string;
    'selected': boolean;
};

@Component({
    'selector': 'app-tracker1HistoricalFilter',
    'templateUrl': './tracker1HistoricalFilter.page.html',
    'styleUrls': ['./tracker1HistoricalFilter.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, MyTimestampPipe ]

})
export class Tracker1HistoricalFilterPage extends ViewBasePage implements OnInit {
    public vm: TVM = {  // Initialize with defaults
        filter: {
            startingDate: null,
            endingDate: null,
            minimumTripDurationMins: 0,
            allDriverNames: [],
            selectedDrivers: [],
            dateRangeStart: null,
            dateRangeEnd: null
        },
        tripData: {
            currentIndex: 0,
            trips: null
        }
    };
    private selectedStartDate: TTimestamp;
    private selectedEndDate: TTimestamp;

    constructor(private tripsService: TripsService, private usersService: UsersService,
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_TRACKER_HISTORICAL);
    }

    public override async ngOnInit() {
        const accountProfile = this.sessionService.getAccountProfile();
        const dateRangeStart = accountProfile.signupDate;
        const dateRangeEnd = this.dateService.now();
        this.selectedStartDate = dateRangeStart;
        this.selectedEndDate = dateRangeEnd;

        const signupDate = dateRangeStart;
        // const startingDate = this.dateService.formatTimestamp(signupDate, DateTimeFormats.BigDate);
        // const startingDate = this.dateService.setHoursMinutesSeconds(signupDate, 0, 0, 0);
        // const endingDate = this.dateService.formatTimestamp('now', DateTimeFormats.BigDate);
        // const endingDate = this.dateService.setHoursMinutesSeconds('now', 23, 59, 59);
        const startingDate = this.dateService.adjustTimeBoundary(signupDate, 'start');
        const now = this.dateService.now();
        const endingDate = this.dateService.adjustTimeBoundary(now, 'end');

        const allDrivers = await this.usersService.getUsersByRole('driver');
        const allDriverNames = allDrivers.map(driver => driver.firstName + ' ' + driver.lastName);
        // const selectedDrivers = 'All Drivers';
        const selectedDrivers = allDriverNames;

        this.vm = {
            filter: {
                'startingDate': startingDate,
                'endingDate': endingDate,
                'minimumTripDurationMins': 0,
                'allDriverNames': allDriverNames,
                'selectedDrivers': selectedDrivers,
                'dateRangeStart': startingDate,
                'dateRangeEnd': endingDate
            },
            tripData: {
                currentIndex: 0,
                trips: null
            }
        };
        // this.initMoreMenu();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-tracker-historical-1-tour');
    // }

    // public ionViewWillLeave() {
    //     const verified = this.verifyDateRange();
    //     if (verified) {
    //         this.setViewModel(this.vm.filter);
    //         // this.router.navigateByUrl('/trackerHistorical/tabs/historicalTrackingTrips');
    //     }    
    // }

    public async onNextClick() {
        if (this.verifyDateRange()) {
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/tracker/tracker2HistoricalTrips');
        }
    }

    private verifyDateRange(): boolean {
        // const startdate = this.dateService.parse(this.vm.filter.startingDate, DateTimeFormats.BigDate);
        // const enddate   = this.dateService.parse(this.vm.filter.endingDate, DateTimeFormats.BigDate);
        // if (startdate > enddate) {
        //     this.uxHelperService.showAlert('Error', 'Starting Date must be before Ending Date.');
        //     return false;
        // }

        if (this.vm.filter.startingDate > this.vm.filter.endingDate) {
            this.uxHelperService.showAlert('Error', 'Starting Date must be before Ending Date.');
            return false;
        }

        return true;
    }

    public async onSelectDriversClick(): Promise<void> {
        try {
            // Build the list of selectable items of the modal
            const selectables: TSelectable[] = [];
            this.vm.filter.allDriverNames.forEach((driverName: any) => {
                // const line1 = driver.firstName + ' ' + driver.lastName;
                // const line2 = driver.selected ? 'selected' : 'not selected';

                const selectable: TSelectable = {
                    'line1': driverName,
                    // 'selected': driver.selected
                    'selected': false
                };
                selectables.push(selectable);
            });

            const response = await this.openCheckboxModal(selectables);
            if (response.data.okay) {
                if (response.data.selectedItems) {
                    const selectedDriverNames = response.data.selectedItems.map((item) => item.line1);
                    this.vm.filter.selectedDrivers = selectedDriverNames.join(', ');
                }
            }

            // const title = 'Select Drivers';
            // const driverNames = this.vm.filter.allDriverNames;
            // const response = await this.uxHelperService.showCheckboxAlert(title, driverNames, this.vm.filter.selectedDrivers);
            // if (response.selection) {
            //     this.vm.filter.selectedDrivers = Array.isArray(response.value) ? response.value : [response.value];
            // }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    private async openCheckboxModal(selectables) {
        const options: ModalOptions = {
            'component': CheckboxModalPage,
            'componentProps': {
                'selectables': selectables,
                'title': 'Select Drivers',
                'showTestCustomerButton': false
            },
            'backdropDismiss': true,
            'showBackdrop': true,
            'cssClass': 'myModalSize'
        };

        const myModal: HTMLIonModalElement = await this.modalController.create(options);
        await myModal.present();
        
        const response = await myModal.onDidDismiss();
        return response;
    }

    // private async openCheckboxAlert(selectables): Promise<TAlertResponse> {
    //     this.uxHelperService.showCheckboxAlert()
    // }

    public async onFilterStartingDateClick(): Promise<void> {
        // const response: TResponse = await this.openCalendarModal(
        await this.openCalendarModal(
            this.vm.filter.dateRangeStart, this.vm.filter.dateRangeEnd,
            this.selectedStartDate, 'Select Starting Date');

        // if (response.okay) {
        //     this.selectedStartDate = this.dateService.toTimestamp(response.selectedItems[0]);
        // }
    }

    public async onFilterEndingDateClick(): Promise<void> {
        // this.selectedEndDate = await this.openCalendarModal(
        //     this.vm.filter.dateRangeStart, this.vm.filter.dateRangeEnd,
        //     this.selectedEndDate, 'Select Ending Date');
        // // this.vm.filter.endingDate = this.dateService.formatTimestamp(this.selectedEndDate, Constants.DateTimeFormats.BigDate);
        // this.vm.filter.endingDate = this.selectedEndDate;
    }
}
